<template>
  <AbsPopup id="InputPopup" :title="title" type="confirm" :initButtonList="buttonList" @close="$emit('close')">
    <template #body>
      <div class="popup-body">
        <span>수정하신 내용은 각 서점사에 제공하는 내용이므로 자세하게 작성해주시길 바랍니다.<u>내용이 부적절할 경우 수정 내용이 반영되지 않을 수 있습니다.</u></span>
        <div>
          <span class="right">공백포함 {{ textSize }} / {{ total }}</span>
        </div>
        <div class="box">
          <UInput :type="multiline ? 'textarea' : 'text'" :limitHeight="150" placeholder="내용을 입력해 주세요" v-model="data" :auto="true" :limit="count" @enter="submit" @esc="$emit('close')"/>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'

export default {
  props: {
    option: {
      type: Object
    }
  },
  created () {
  },
  mounted () {
    console.log(this.option)
    this.title = this.option.param.title
    this.multiline = this.option.param.multiline
    this.$emit('loading', false)
  },
  beforeDestroy () {
  },
  data () {
    return {
      title: '',
      multiline: true,
      data: '',
      count: 300,
      total: 300,
      enter: true
    }
  },
  name: 'InputPopup',
  watch: {
  },
  computed: {
    buttonList () {
      return [
        {name: '취소', state: 'deactive', click: () => { this.$emit('close') }},
        {name: '확인', state: 'deactive', click: this.submit}
      ]
    },
    textSize () {
      return this.data.length
    }
  },
  methods: {
    submit () {
      console.log('inputpopup submitHandler')
      this.$emit('submit', this.data)
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
#InputPopup {
  padding: 10px 0;
  width: 450px;
}
.popup-body {
  display: flex;
  flex-direction: column;
  margin: 5px 0px;
  padding: 10px;
  align-items: center;
}
.popup-body > span:first-child {
  text-align: left;
  line-height: 25px;
  margin-bottom: 10px;
}
.popup-body > div {
  display: flex;
  width: 100%;
}
.popup-body .box {
  border: 1px solid var(--line-base);
  align-items: center;
  padding: 0px 10px;
}
.popup-body .input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/InputPopup.vue